import React, { useEffect, useState } from "react";
import {
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Avatar,
  CircularProgress,
  Grid,
} from "@material-ui/core";

import {
  Person,
  HowToVote,
  ThumbUp,
  Today,
  CheckCircleOutline,
  PauseCircleOutline,
} from "@material-ui/icons";

import { Carousel } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import useStyles from "./style";
import { localDateTime } from "../../../utils/dateTime";
import { designContestCollection } from "../../../components/firebase/DataProvider";
import { useDocumentData } from "react-firebase-hooks/firestore";

export default function DesignDialog({
  design,
  handleUpvote,
  handleLike,
  handleApproval,
  isAdmin,
}) {
  const classes = useStyles();
  const [upvotting, setUpvotting] = useState(false);
  const [liking, setLiking] = useState(false);

  const [upvotes, setUpvotes] = useState(0);
  const [likes, setLikes] = useState(0);

  const handleUpvoteModal = async (id, mode) => {
    try {
      setUpvotting(true);

      const upvote = await handleUpvote(id, mode);

      if (!upvote.success) throw new Error(upvote.message);

      setItemData((prev) => {
        return { ...prev, isUpvoted: !itemData.isUpvoted };
      });
    } catch (error) {
      console.log(error.message);
    }

    setUpvotting(false);
  };

  const handleLikeModal = async (id, mode) => {
    try {
      setLiking(true);

      const like = await handleLike(id, mode);

      if (!like.success) throw new Error(like.message);

      setItemData((prev) => {
        return { ...prev, isLiked: !itemData.isLiked };
      });
    } catch (error) {
      console.log(error.message);
    }

    setLiking(false);
  };

  const handleApprovalModal = async (id, mode) => {
    try {
      const approve = await handleApproval(id, mode);

      if (!approve.success) {
        throw new Error(approve.message);
      }

      let newStatus = mode === "approve" ? "approved" : "pending;";

      setItemData((prev) => {
        return { ...prev, status: newStatus };
      });
    } catch (error) {
      console.log(error.message);
    }

    setLiking(false);
  };

  const [itemData, setItemData] = React.useState({
    designContestId: "",
    isLikable: false,
    isVotable: false,
    id: "",
    images: [
      "https://firebasestorage.googleapis.com/v0/b/sommerce-develop.appspot.com/o/design_contest%2Fx1C59jzUybYz0Z0lZF7j%2F5563.jpg?alt=media&token=8352ede0-d48d-44ca-9fc4-5b4dbb153ea1",
    ],
    owner: {
      nama: "Not Found",
      subdomain: "-",
      avatar: "",
    },
    title: "Not Found",
    description: "",
    isUpvoted: false,
    isLiked: false,
    submitted_at: "",
    status: "pending",
  });

  useEffect(() => {
    if (design.id && !itemData.id) setItemData(design);
  }, [design, itemData]);

  const designRef = designContestCollection
    .doc(itemData?.designContestId || "DEFAULT_ID")
    .collection("designs")
    .doc(itemData?.id || "DEFAULT_ID");
  const [dataDesain, loadingDataDesigns] = useDocumentData(designRef, {
    idField: "id",
  });

  useEffect(() => {
    if (!loadingDataDesigns && itemData.id) {
      setUpvotes(() => dataDesain.upvotes);
      setLikes(() => dataDesain.likes);
    }
  }, [loadingDataDesigns, dataDesain, itemData.id]);

  return (
    <>
      <DialogTitle
        id="responsive-dialog-title"
        disableTypography
        className={classes.dialog_head}
      >
        <Grid container>
          <Grid item xs={6}>
            <div className={classes.profile}>
              <Avatar
                style={{
                  color: "white",
                  backgroundColor: "#5675D3",
                  width: "45px",
                  height: "45px",
                }}
              >
                {itemData?.owner?.avatar ? (
                  <img src={itemData.owner.avatar} alt="avatar" width="100%" />
                ) : (
                  <Person
                    style={{
                      width: "35px",
                      height: "35px",
                    }}
                  />
                )}
              </Avatar>
              <div
                className={classes.profile_capt}
                onClick={(e) => e.preventDefault()}
                style={{
                  color: "#081328",
                }}
              >
                <Typography
                  variant="h6"
                  component="h6"
                  className={classes.profile_name}
                  style={{
                    display: "flex",
                    fontWeight: "bold",
                  }}
                >
                  {itemData?.title || "-"}
                  {isAdmin ? (
                    <span
                      style={{
                        marginLeft: "10px",
                        display: "flex",
                        alignItems: "center",
                        color:
                          itemData.status === "approved" ? "green" : "orange",
                      }}
                      onClick={() => {
                        let mode =
                          itemData.status === "pending" ? "approve" : "pending";
                        handleApprovalModal(itemData.id, mode);
                      }}
                    >
                      {itemData.status === "approved" ? (
                        <CheckCircleOutline />
                      ) : (
                        <PauseCircleOutline />
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </Typography>
                <Typography
                  variant="h6"
                  component="p"
                  className={classes.profile_subdomain}
                >
                  {itemData?.owner?.nama}
                </Typography>
              </div>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.action_button}>
              {itemData.isVotable && itemData.status === "approved" ? (
                <button
                  className={classes.upvote}
                  disabled={upvotting || !itemData.id}
                  style={{
                    ...(itemData.isUpvoted ? { color: "#5675D3" } : null),
                    border: `1px solid ${
                      itemData.isUpvoted ? "#5675D3" : "grey"
                    }`,
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleUpvoteModal(
                      itemData.id,
                      itemData.isUpvoted ? "down" : "up"
                    );
                  }}
                  title="vote"
                >
                  {upvotting ? (
                    <CircularProgress
                      size={20}
                      style={{
                        color: "grey",
                      }}
                    />
                  ) : (
                    <HowToVote
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  )}
                </button>
              ) : (
                ""
              )}

              {itemData.isLikable || isAdmin ? (
                <button
                  className={classes.upvote}
                  disabled={liking || !itemData.id}
                  style={{
                    ...(itemData.isLiked ? { color: "#5675D3" } : null),
                    border: `1px solid ${
                      itemData.isLiked ? "#5675D3" : "grey"
                    }`,
                    marginLeft: "8px",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleLikeModal(
                      itemData.id,
                      itemData.isLiked ? "down" : "up"
                    );
                  }}
                  title="like"
                >
                  {liking ? (
                    <CircularProgress
                      size={20}
                      style={{
                        color: "grey",
                      }}
                    />
                  ) : (
                    <ThumbUp
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  )}
                </button>
              ) : (
                ""
              )}
            </div>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.dialog_content}>
        <Carousel autoPlay={false} showThumbs={false} emulateTouch={true}>
          {itemData?.images?.map((item, index) => {
            return (
              <div key={index} item={item}>
                <img
                  className={classes.hero}
                  src={item}
                  alt="hero"
                  loading="lazy"
                />
              </div>
            );
          })}
        </Carousel>
        <DialogContentText
          component="div"
          className={classes.dialog_content_text}
        >
          <Typography
            variant="h5"
            component="h5"
            style={{
              fontWeight: "bold",
              marginBottom: "10px",
              textAlign: "center",
              color: "black",
            }}
          >
            {itemData?.title || "-"}
          </Typography>

          <div
            style={{
              display: "flex",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                display: "flex",
                marginRight: "15px",
              }}
            >
              <Today
                style={{
                  width: "16px",
                  height: "16px",
                }}
              />
              <span
                style={{
                  marginLeft: "3px",
                }}
              >
                {design?.submitted_at
                  ? localDateTime(design.submitted_at.seconds * 1000)
                  : localDateTime(Date.now())}
              </span>
            </span>

            {isAdmin ? (
              <>
                <span
                  style={{
                    fontSize: "12px",
                    display: "flex",
                    marginRight: "15px",
                  }}
                >
                  <HowToVote
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                  <span
                    style={{
                      marginLeft: "3px",
                    }}
                  >
                    {upvotes || 0} vote
                  </span>
                </span>
                <span
                  style={{
                    fontSize: "12px",
                    display: "flex",
                    marginRight: "15px",
                  }}
                >
                  <ThumbUp
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                  <span
                    style={{
                      marginLeft: "3px",
                    }}
                  >
                    {likes || 0} like
                  </span>
                </span>
              </>
            ) : (
              ""
            )}
          </div>

          {itemData?.description ? (
            <Typography
              variant="subtitle1"
              component="p"
              className={classes.description_text}
            >
              {itemData?.description || "-"}
            </Typography>
          ) : (
            ""
          )}

          {isAdmin ? (
            <>
            <div style={{
              marginTop: '10px'
            }}>
              <Typography variant="subtitle1">
                Desainer: {itemData?.owner?.nama} ({itemData?.owner?.usia || 0}), {itemData?.owner?.profesi || "-"}
              </Typography>
              <Typography variant="subtitle1">
                Domisili: {itemData?.owner?.domisili || "-"}
              </Typography>
            </div>
            <embed src={itemData?.philosophy} type="application/pdf" width="100%" height="500px" style={{
              marginTop: '10px'
            }} />
            </>
          ) : (
            ""
          )}
        </DialogContentText>
      </DialogContent>
    </>
  );
}
